<template>
  <div :style="styles" class="keyVisualWrapper">
    <div>
      <img class="desktop_img img-fluid w-100" :src="desktopImageUrl" />
      <img class="mobile_img img-fluid w-100" :src="mobileImageUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: "key-visual",
  props: {
    desktopImageUrl: {
      type: String,
      required: true
    },
    mobileImageUrl: {
      type: String,
      required: true
    },
    styles:{
      type:Object,
      default:()=>{}
    }
  }
};
</script>

<style scoped lang="scss">
  .keyVisualWrapper {
    /*need to change the MIME on S3 */
    /*background-image: url(https://jolt-assets.s3.eu-central-1.amazonaws.com/template/pampers_leafs.svg);*/
    background-repeat: no-repeat;
    position: relative;
  }

  .desktop_img {
    @media (max-width: 425px) {
      display: none;
    }
  }

  .mobile_img {
    @media (min-width: 425.9px) {
      display: none;
    }
  }

</style>
